import React from 'react';

const Vue_mounted = () => {
  return (
    <div>
      <h1>Vue_mounted Component</h1>
      <p>This is the Vue_mounted tutorial page.</p>
    </div>
  );
}

export default Vue_mounted;
